import type { TransactionInitializeMutationVariables } from '@/graphql/saleor/api';
import { useTransactionInitializeMutation } from '@/graphql/saleor/api';
import type { TransactionAction, TransactionType } from '@/lib/payment/types';
import { getCurrentUrl, getOrigin } from '@/lib/util';
import { useRegionProvider } from '@/providers/RegionProvider';

export const useTransactionInitialize = (
  orderOrCheckoutId: string,
  billingAddressCountryCode?: string,
) => {
  const [transactionInitialize] = useTransactionInitializeMutation();
  const { country, locale } = useRegionProvider();

  return async ({
    action,
    amount,
    data,
    type,
    ...opts
  }: Partial<TransactionInitializeMutationVariables> & {
    action: TransactionAction;
    type: TransactionType;
  }) =>
    await transactionInitialize({
      variables: {
        id: orderOrCheckoutId,
        amount: amount,
        data: {
          origin: getOrigin(),
          returnUrl: getCurrentUrl(),
          countryCode: billingAddressCountryCode || country.code,
          shopperLocale: locale.locale,
          shopperIP: '',
          action,
          type,
          ...data,
        },
        ...opts,
      } as TransactionInitializeMutationVariables,
    });
};
